import { Component, OnInit } from '@angular/core';
import { Environment } from 'src/app/config/environment';
import { Busqueda, Models } from './models/models';
import { Utils } from 'src/app/commons/utils';
import {  AlertModel, ALERT_TYPE } from '../shared/alert/alert.component';
import { BaseComponent } from '../shared/base.component';
import { CommonDataService } from 'src/app/services/commons/commondata.service';
import { DeliveryService } from '../../services/delivery/delivery.service';
import { Vendor } from '../../component/precheck/models/models';
import { InternalDeliveryService } from '../../services_internal/internalDelivery/internalDelivery.service'

import { ExcelExportService } from 'src/app/services/excelExport/excel.export.service';
import 'datatables.net';


@Component({
  selector: 'app-consulta',
  templateUrl: './contador.component.html',
  styleUrls: ['./contador.component.css']
})

export class ContadorComponent extends BaseComponent  implements OnInit {
  public busqueda: Busqueda = new Busqueda;
  public title: string = "Contador de Transacciones";
  public es: any;
  public alertMessage: AlertModel = new AlertModel;
  public showSearch: boolean; 
  public loading: boolean;
  public modelos : Array<any>
  public resultsDataModels: Models[] = []
  public resultsDataModel: Models[] = []
  public resultsDataModelDetail: Models[] = []
  public showResult : boolean;
  public modelResult : boolean;
  public modelResultDetail : boolean;
  public tablereports1 = null;
  public tablereports2 = null;
  public total : number = 0;
  public totalModel : number = 0;
  public totalPcn : number = 0;
  public caracteristica :string;
  public modelo : string;
  public tipoDeVentaList : Array<any> = new Array<any>();
  
  constructor(private commonDataService: CommonDataService,  private deliveryService: DeliveryService,
    private deliveryInternalsService: InternalDeliveryService, private excelExportService: ExcelExportService ){
    super();
  }
    ngOnInit(): void {     
      this.setCalendarLocale();
      this.loadModels();
      this.showSearch = true;  
      this.modelResult = false
      this.busqueda.modelo = ""
      this.caracteristica="";
      this.busqueda.tipoVenta="TODOS";
      this.fillTipodeVenta();
     
      

      

    }
    setCalendarLocale(){

      this.es = Environment.CalendarLanguageSetting;
    }


    loadReportResults(){

      if(!Utils.dateIsValid(this.busqueda.fechaDesde)) {
        this.alertMessage = new AlertModel("Fecha Desde es requerida.", this.title, true, ALERT_TYPE.INFO);
        return;
      }

      if(!Utils.dateIsValid(this.busqueda.fechaHasta)) {
        this.alertMessage = new AlertModel("Fecha Hasta es requerida.", this.title, true, ALERT_TYPE.INFO);
        return;
      }

      if(Utils.dateIsValid(this.busqueda.fechaDesde) &&
        Utils.dateIsValid(this.busqueda.fechaHasta)){
        let cap_days =  Utils.dateDiffBetween(this.busqueda.fechaDesde, this.busqueda.fechaHasta, "days");
  
        if(cap_days < 0){
          this.alertMessage = new AlertModel("Fecha: Desde debe ser mayor que Hasta.",this.title,true);
          return;
        }  
    
      } 
     this.loadReportRequest() 
    }
loadModels() {
  this.loading = true; 
  this.commonDataService.getModelos().subscribe({
    next: (response) => {
      if (response.status == 200 && response.body != null) {
        this.modelos = Object.assign([], response.body);
      } else if (response.status == 204) {
        console.log("no se encontraron modelos");
      } else {
        console.log("Error 1 obteniendo modelos");
      }
      this.loading = false; 
    },
    error: (err) => {
      console.log("Error 2 obteniendo modelos");
      this.loading = false; 
      this.alertMessage = new AlertModel("Error al cargar los modelos", this.title, true);
    },
    complete: () => {
      this.loading = false; 
    }
  });
}



    
    loadReportRequest(){  

      let request = { 
    
        "fechaDesde": Utils.isNullOrEmpty(this.busqueda.fechaDesde) ? null : this.busqueda.fechaDesde, 
        "fechaHasta": Utils.isNullOrEmpty(this.busqueda.fechaHasta) ? null : this.busqueda.fechaHasta, 
        "modelo": Utils.isNullOrEmpty(this.busqueda.modelo) ? null : this.busqueda.modelo,  
        "cuil": Utils.isNullOrEmpty(this.busqueda.cuil) ? null : this.busqueda.cuil,  
        "pcn": Utils.isNullOrEmpty(this.busqueda.pcn) ? null : this.busqueda.pcn, 
        "tipoVenta": Utils.isNullOrEmpty(this.busqueda.tipoVenta) ? null : this.busqueda.tipoVenta,  
      };
      var v = Utils.isNullOrEmpty(this.busqueda.modelo)
    
      this.modelo = request.modelo
   
      this.loading = true;
      this.loadReportRequest1(request);
   
  }
loadReportRequest1(busqueda) {
  let request = {
    "fechaDesde": busqueda.fechaDesde,
    "fechaHasta": busqueda.fechaHasta,
    "modelo": busqueda.modelo,
    "cuil": busqueda.cuil,
    "pcn": busqueda.pcn,
    "tipoVenta": busqueda.tipoVenta
  };

  this.loading = true;
  this.commonDataService.getApplicantForModels(request).subscribe({
    next: (data) => {
      if (data) {
        this.resultsDataModels = data['modelosCant'];
        this.resultsDataModel = data['modelosCantTotal'];
        this.total = data['total'];
        this.showSearch = true;
        this.showResult = true;
        this.modelResultDetail = false;
        this.modelResult = false;
        this.setupTable();
      } else {
        console.error('No se recibieron datos');
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
        this.loading = false;
      }
    },
    error: (error) => {
      console.error(error);
      this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
      this.loading = false;
    },
    complete: () => {
      this.loading = false;
    }
  });
}

getApplicantForModel(caracteristica: string, fechaDesde: string, fechaHasta: string) {
  let request = {
    "fechaDesde": fechaDesde,
    "fechaHasta": fechaHasta,
    "modelo": this.modelo,
    "caracteristica": caracteristica
  };

  this.caracteristica = caracteristica;
  this.showSearch = true;
  this.showResult = false;
  this.loading = true;
  this.modelResult = false;
  this.modelResultDetail = true;

  this.commonDataService.getApplicantForModel(request).subscribe({
    next: (data) => {
      if (data) {
        this.resultsDataModelDetail = data['modelosCant'];
        this.totalPcn = data['total'];
        this.setupTable();
      } else {
        console.error('No se recibieron datos');
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
      }
    },
    error: (error) => {
      console.error(error);
      this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
    },
    complete: () => {
      this.loading = false;
    }
  });
}

showModels(modelo: string, fechaDesde: string, fechaHasta: string, totalModel: number) {
  let request = {
    "fechaDesde": fechaDesde,
    "fechaHasta": fechaHasta,
    "modelo": modelo
  };

  if (totalModel != 0 && this.totalModel != totalModel) {
    this.totalModel = totalModel;
  }

  this.modelo = modelo;
  this.showSearch = true;
  this.showResult = false;
  this.loading = true;
  this.modelResultDetail = false;
  this.modelResult = true;

  this.commonDataService.getDataModel(request).subscribe({
    next: (data) => {
      if (data) {
        this.resultsDataModel = data['modelosCant'];
        this.setupTable();
      } else {
        console.error('No se recibieron datos');
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
      }
    },
    error: (error) => {
      console.error(error);
      this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
    },
    complete: () => {
      this.loading = false;
    }
  });
}


setupTable(){

  this.showResult = true;
  this.loading = false;

  if (this.tablereports1 != null) {
   this.tablereports1.clear().destroy();
  } 
  
  $(document).ready( () => {
    
      this.tablereports1 =   $("#result-table").DataTable({

      searching: true, 
      paging: true, 
      
      lengthChange: false,
      pageLength: 10,
      pagingType: 'full_numbers',
      destroy:true,
      columnDefs: [
        { targets: 'no-sort', orderable: false }
      ],        
      language: Environment.DataTableLanguageSetting,
     
     });


  });

  return true;
}







fillTipodeVenta(){
  this.tipoDeVentaList.push("PROSPECT")
  this.tipoDeVentaList.push("CUSTOMER SUP")
  this.tipoDeVentaList.push("CUSTOMER REVERSE/UPGRADE")
 
  
}
exportar() {
    let reportExport = new Array<any>();

    this.resultsDataModels.forEach(model => {
        reportExport.push({
            "CUIL": model.cuil,
            "DNI": model.dni,
            "PCN": model.pcn,
            "Modelo": model.modelo,
            "Tipo de Venta": model.tipoVenta,
            "Función": model.funcion,
            "Fecha": model.fecha,
            "Cantidad": model.count
        });
    });

    // Asumiendo que tienes el servicio de exportación a Excel
    this.excelExportService.exportAsExcelFile(reportExport, 'Reporte_Contador');
}

}